import client from '@common/utils/rest';
import { getFilters } from '@common/actions/Filters';
import { SORT_DIRECTION } from '@common/constants';
import { ORDERS_PATIENTS_ACTION_TYPES } from '../const/patients';
import { getQueriesAsSearch } from '@common/utils';

const URL_PREFIX = 'ambry/orders/data/';

const setPatients = (payload) => {
  return {
    payload,
    type: ORDERS_PATIENTS_ACTION_TYPES.setList,
  };
};

const setPatientsCount = (payload) => {
  return {
    payload,
    type: ORDERS_PATIENTS_ACTION_TYPES.setListCount,
  };
};

export const resetPatients = () => {
  return setPatients([]);
};

export const getPatients = ({ filtering, pagination, sorting }) => (dispatch, getState) => {
  const { searchKeyword, ...otherFilteringQueries } = filtering;

  const params = {
    searchQuery: searchKeyword,
    ...otherFilteringQueries,
    ...pagination,
    sortColIndex: sorting.columnIndex ?? 1,
    sort: true,
    sortAsc: sorting.direction === SORT_DIRECTION.asc
  };

  return client({
    path: `${URL_PREFIX}individuals${getQueriesAsSearch(params)}`,
    method: 'GET',
  }).then((response) => {
    const shouldReset = pagination.start === 0;
    
    if (shouldReset) {
      dispatch(resetPatients());
    }

    const { list } = getState().patients;

    dispatch(setPatients([...list, ...response.entity.individualData]));
    dispatch(setPatientsCount(response.entity.totalIndividualsCount));
  });
};

const setPatientsFilters = (payload) => {
  return {
    payload,
    type: ORDERS_PATIENTS_ACTION_TYPES.setFilters,
  };
};

export const getPatientsFilters = () => (dispatch) => {
  return getFilters().then((response) => {
    dispatch(setPatientsFilters(response));
  });
};

export const getPatientsFolders = () => {
  return client({
    path: `${URL_PREFIX}folders`,
    method: 'GET',
  }).then((response) => {
    const foldersByType = response.entity.individualFolders.reduce((acc, folder) => {
      if (folder.system) {
        folder.imageURL = 'gif/system.gif';
        folder.imageURLSelected = 'gif/system.gif';

        acc.system.push(folder);
      } else {
        acc.individuals.push(folder);
      }

      return acc;
    }, { individuals: [], system: [] })
    
    const createRootFolder = ({ id, name, children, imageURL, system }) => {
      return {
        id, 
        name,
        children,
        imageURL,
        system,
        imageURLSelected: imageURL,
      };
    };

    const ROOT_SYSTEM_FIELDS_ID = 0;

    const systemRootFolder = createRootFolder({
      id: ROOT_SYSTEM_FIELDS_ID,
      name: 'System Fields',
      children: foldersByType.system,
      imageURL: 'gif/system.gif',
      system: true,
    });
    const patientsRootFolder = createRootFolder({
      id: '',
      name: 'Individual Data Folders',
      children: foldersByType.individuals,
      imageURL: 'gif/df_individual.gif',
      system: false,
    });

    return [
      systemRootFolder,
      patientsRootFolder
    ];
  });
};

export const getPatientsFolderFields = ({ searchKeyword, folderId, system }) => {
  return client({
    params: {
      system,
      searchQuery: searchKeyword,
      parentId: folderId,
    },
    path: `${URL_PREFIX}folders/fields`,
    method: 'GET',
  }).then((response) => {
    return response.entity.fieldsData;
  });
};

export const addColumnToPatientsTable = (params) => {
  return client({
    params: {
      fieldId: params.fieldId,
      fieldContext: params.fieldContext,
      fieldType: params.fieldTypeId,
      fieldName: params.fieldName,
      system: params.systemField,
    },
    path: `${URL_PREFIX}column/add`,
    method: 'POST',
  });
};

export const setPatientsColumnsWidth = ({ width, columnIndex }) => {
	return client({
    params: {
      width,
      columnIndex,
    },
		path: `${URL_PREFIX}column/width`,
		method: 'POST',
	});
};